import useViewsSelector from "views/stores/useViewsSelector";
import { selectSearchExecutionResult } from "views/logic/slices/searchExecutionSelectors";
const useSearchResult = () => useViewsSelector(selectSearchExecutionResult);
export default useSearchResult;
